module.exports = __webpack_public_path__ + "img/icon_phone.ff0e366c.png";